import { Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography } from '../../../molecules/Typography';
import { Colors, IMaterial, IPodcasts } from '../../../../models/disciplines';
import ContentCard from '../../ContentCard';
import formatFileCategory from '../../../../commom/formatFileCategory';
import { formatTime } from '../../../../commom/formatTime';
import { useFreemiumLock } from '../../FreemiumLockModal/useFreemiumLock';

interface PodcastsSectionProps {
  title: string;
  linkTo: string;
  showLink: boolean;
  children: React.ReactNode;
}

function PodcastsSection({
  title,
  linkTo,
  showLink,
  children,
}: PodcastsSectionProps) {
  return (
    <div className='xs:basis-full lg:basis-1/3'>
      <div className='mb-4 flex flex-row items-end justify-between'>
        <Typography
          type='titleSection'
          size='h5'
          className='text-mono-color-dark'
        >
          {title}
        </Typography>
        {showLink && (
          <Link to={linkTo} className='text-sm text-color-brand-primary'>
            Ver mais
          </Link>
        )}
      </div>
      <div className='flex flex-col gap-md'>{children}</div>
    </div>
  );
}

interface RelatedContentProps {
  discipline: string;
  module?: string;
  data: any;
  isPending: boolean;
  onFavoriteCallback?: (data: any) => void;
  onDone?: (id: string, slug: string) => void;
}

const Podcasts = ({
  discipline,
  module,
  data,
  onFavoriteCallback,
  onDone,
}: RelatedContentProps) => {
  const navigate = useNavigate();
  const { isLocked, openLock } = useFreemiumLock();
  return (
    <Fragment>
      <PodcastsSection
        title='PODCASTS'
        linkTo={`/disciplinas/${discipline}/modulo/${module}/tipo/podcasts`}
        showLink={data?.podcast.length === 2}
      >
        {data?.podcast.map((it: IPodcasts, i: number) => {
          const locked = isLocked(it);
          return (
          <ContentCard
            color={discipline as Colors}
            key={it.id || i}
            title={it.title}
            done={it.done}
            favorite={it.favorite}
            icon='mic'
            content='podcast'
            action={() =>
              locked
                ? openLock()
                : navigate(
                    `/disciplinas/${discipline}/modulo/${module}/tipo/podcast`
                  )
            }
            subject={it.subjects[0].title}
            id={it.id}
            slug={it.slug}
            hasCallback={!!onFavoriteCallback}
            callback={onFavoriteCallback}
            onDone={onDone}
            doneLoading={false}
            locked={locked}
          >
            <Typography
              size='small'
              className='transition delay-100 ease-in-out group-hover:text-card-color-default'
            >
              {it.duration ? formatTime(it.duration) : ''}
            </Typography>
          </ContentCard>
          );
        })}
      </PodcastsSection>
    </Fragment>
  );
};

export default Podcasts;
